// extracted by mini-css-extract-plugin
export default {"root":"RotateIcon_root__JjpUv"};